import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import {
  LogOut,
  Building2,
  Wrench,
  MessageSquare,
  ShieldCheck,
  ShoppingCart,
  Sun,
  Moon,
  SunMoon
} from 'lucide-react'

import { client } from '@helpers/api'
import { useCurrentUser } from '@contexts/currentUser'
import Navbar from '@components/Navbar/Navbar'
import { useTheme } from '@components/ThemeProvider'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuCheckboxItem
} from '@/components/ui/dropdown-menu'

const apiUrl = import.meta.env.VITE_API_URL

const AdminThemeSwitcher = () => {
  const { theme, setTheme } = useTheme()

  let CurrentThemeIcon = SunMoon
  if (theme === 'light') {
    CurrentThemeIcon = Sun
  } else if (theme === 'dark') {
    CurrentThemeIcon = Moon
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center w-full gap-x-2 p-2 rounded-lg text-sm text-left hover:bg-accent focus:bg-accent focus:outline-none">
          <CurrentThemeIcon className="h-4 w-4" />
          <span>Theme</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" align="start" className="w-[var(--radix-dropdown-menu-trigger-width)]">
        <DropdownMenuCheckboxItem
          checked={theme === 'light'}
          onClick={() => setTheme('light')}
          className="cursor-pointer"
        >
          Light
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          checked={theme === 'dark'}
          onClick={() => setTheme('dark')}
          className="cursor-pointer"
        >
          Dark
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          checked={theme === 'system'}
          onClick={() => setTheme('system')}
          className="cursor-pointer"
        >
          System
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

const AdminNav = ({ children }) => {
  const navigate = useNavigate()
  const { clearUser } = useCurrentUser()
  const queryClient = useQueryClient()
  const { mutate: signOut } = useMutation(['signOut'], async () => client.delete('/users/sign_out'),
    {
      onSuccess: () => {
        clearUser()
        queryClient.clear()
        navigate('/sign_in')
      }
    }
  )

  const navigation = [
    { name: 'Organizations', href: '/admin/organizations', icon: Building2 },
    { name: 'Tutors', href: '/admin/tutors', icon: MessageSquare },
    { name: 'Security settings', href: '/admin/security', icon: ShieldCheck },
    {
      name: 'Admin tools',
      href: `${apiUrl}/admin`,
      icon: Wrench,
      onClick: () => window.open(`${apiUrl}/admin`, '_blank', 'noopener,noreferrer')
    }
  ]

  const signOutSetting = { name: 'Sign out', icon: LogOut, onClick: signOut }

  return (


    <Navbar>
      <Navbar.Header>
        <Navbar.Logo />
      </Navbar.Header>
      <Navbar.Content>
        <Navbar.List items={navigation} />
      </Navbar.Content>
      <Navbar.Footer>
        <div className="p-2">
          <AdminThemeSwitcher />
        </div>
        <Navbar.List items={[signOutSetting]} />
      </Navbar.Footer>
    </Navbar>
  )
}

export default AdminNav
